<template>
  <div class="vuestic-pre-loader">
    <pixel-spinner
          :animation-duration="1000"
          color="'#e34a4a'"
     />
  </div>
</template>

<script>
  import {PixelSpinner} from 'epic-spinners'

  export default {
    name: 'vuestic-pre-loader',
    components: {
      PixelSpinner
    }
  }
</script>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-preloader/VuesticPreLoader.vue